import { request } from '../helpers/request';

export const exportsApi = {
  bundle: (
    projectId: string,
    language: string,
    format: 'nested' | 'flat',
    includeUnapproved = false,
  ) =>
    request<Record<string, unknown>>(
      `/projects/${projectId}/exports/${language}`,
      { params: { format, includeUnapproved } },
    ),
};
